export const logo = require("../assets/image_logo.png");
export const infoIcon = require("../assets/info_icon.png");
export const userIcon = require("../assets/user_icon.png");
export const calendarIcon = require("../assets/calendar.png");
export const searchIcon = require("../assets/searchicon.png");